module.exports = __webpack_public_path__ + "img/testimonials_marquee.fb6ee80f.png";